const websiteId = 'e5ecf1fd-6968-4212-99f7-f9ca5d5e55e8';

export default {
    install: (app) => {
        window._mfq = window._mfq || [];
        (function () {
            var mf = document.createElement('script');
            mf.type = 'text/javascript';
            mf.defer = true;
            mf.src = `//cdn.mouseflow.com/projects/${websiteId}.js`;
            document.getElementsByTagName('head')[0].appendChild(mf);
        })();

        app.config.globalProperties.$mf = {
            tag,
            setVariable,
            formSubmitAttempt,
            formSubmitSuccess,
            formSubmitFailure
        };
    }
};

export function tag(value) {
    window._mfq.push(['tag', value]);
}

export function setVariable(key, value, scope, overwrite) {
    window._mfq.push(['setVariable', key, value, scope, overwrite]);
}

export function formSubmitAttempt(formId) {
    window._mfq.push(['formSubmitAttempt', formId]);
}

export function formSubmitSuccess(formId) {
    window._mfq.push(['formSubmitSuccess', formId]);
}

export function formSubmitFailure(formId) {
    window._mfq.push(['formSubmitFailure', formId]);
}
